export var graphData = {
  computed: {
    donutGraph: function () {
      return {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return 'Buy : ' + params.data.value;
          }
        },
        legend: {
          show: false,
          top: "5%",
          left: "center",
        },
        graph_colors: [],
        series: [
          {
            name: 'Recommendation',
            startAngle: 180,
            endAngle: 360,
            type: "pie",
            radius: ["40%", "65%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            label: {
              // // formatter: `{d}%`,
              // formatter: function (params) {
              //   console.log(params);
              //   // return 'Buy : ' + params.data.value + '(' + params.data.valueInPercent + ')';
              // },
              position: 'inner',
              fontSize: 14,
            },
            labelLine: {
              show: false,
            },
            data: this.donutGraphData,
          },

        ],
      };

    },
  },
  data() {
    return {
      donutGraphData: [],
      initOptions: {
        renderer: "svg"
      },
      loading: true,
    };
  },
};